<template>
  <!-- eslint-disable vue/no-v-html -->
  <template v-if="highlight[fieldName]">
    <span
      v-for="(val, i) of highlight[fieldName]"
      :key="i"
      v-html="DOMPurify.sanitize(val)"
    />
  </template>
  <span v-else>{{ value }}</span>
</template>

<script lang="ts" setup>
import DOMPurify from 'dompurify';
import { toRefs } from 'vue';

import { QuickSearchHighlight } from '@/model';

const props = defineProps<{
  /**
   * The value to display if `fieldName` is not present in `highlight`
   */
  value: string | undefined;
  /**
   * The `fieldName` to display if present in `highlight
   */
  fieldName: string;
  /**
   * The `highlight` field from an elasticsearch result
   */
  highlight: QuickSearchHighlight;
}>();

const { fieldName, value, highlight } = toRefs(props);
</script>
